import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function BiggestTradingDays({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    return (
        <ChartSection id="biggest-days" title="What days did Congress trade the most?" subtitle="Top 15 highest-volume single trading days. What was happening in the market?">
            <Box sx={{ height: 400 }}>
                <ResponsiveBar
                    data={data} keys={['count']} indexBy="date"
                    layout="horizontal"
                    margin={{ top: 10, right: 40, bottom: 40, left: 100 }}
                    padding={0.3} borderRadius={3}
                    colors={[colors.primary]}
                    enableLabel label={d => d.value + ' trades'}
                    labelTextColor="#ffffff"
                    axisBottom={{ legend: 'Trades', legendPosition: 'middle', legendOffset: 32 }}
                    tooltip={({ data: d, color }) => (
                        <ChartTooltip
                            title={d.date}
                            rows={[{ label: 'Trades', value: d.count.toLocaleString(), color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
